<div class="quiz-modal">
  <button class="btn-close" (click)="closeDialog()" aria-label="Close dialog">
    <i class="bi bi-x-lg"></i>
  </button>

  <ng-container *ngIf="isLoading; else pageContent">
    <div class="loading-state">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Fetching quiz details...</p>
    </div>
  </ng-container>

  <ng-template #pageContent>
    <div class="modal-body">
      <div class="hero-section">
        <div class="badge-pulsating">
          <img src="assets/images/student_card_2.svg" alt="Quiz Icon" />
        </div>
        <h2 class="modal-title" matTooltip="{{quizData?.quiz_name}}">{{ quizData?.quiz_name }}</h2>
        <div class="author-tag">
          <img src="assets/images/person.svg" alt="" aria-hidden="true" />
          <span>{{ quizData?.teacher_name || 'Al-BeExpert Instructor' }}</span>
        </div>
      </div>

      <div class="stats-grid">
        <div class="stat-item">
          <div class="stat-icon-wrapper blue">
            <img src="assets/images/unknown_document.svg" alt="" />
          </div>
          <div class="stat-info">
            <span class="label">Questions</span>
            <span class="value">{{ quizData?.total_questions || 0 }}</span>
          </div>
        </div>

        <div class="stat-item">
          <div class="stat-icon-wrapper green">
            <img src="assets/images/rewarded.svg" alt="" />
          </div>
          <div class="stat-info">
            <span class="label">Total Points</span>
            <span class="value">{{ quizData?.total_marks || 0 }}</span>
          </div>
        </div>

        <div class="stat-item">
          <div class="stat-icon-wrapper orange">
            <img src="assets/images/clock_analog.svg" alt="" />
          </div>
          <div class="stat-info">
            <span class="label">Time Limit</span>
            <span class="value">{{ formatTimeLimit(quizData?.time_limit) }}</span>
          </div>
        </div>

        <div class="stat-item">
          <div class="stat-icon-wrapper purple">
            <img src="assets/images/calendar_today.svg" alt="" />
          </div>
          <div class="stat-info">
            <span class="label">Published</span>
            <span class="value">{{ quizData?.published_date | date:'dd MMM' }}</span>
          </div>
        </div>
      </div>

      <div class="warning-alert">
        <i class="bi bi-exclamation-triangle-fill"></i>
        <span>Timer starts immediately. No pauses allowed.</span>
      </div>

      <div class="action-footer">
        <button class="btn-primary-gradient" (click)="startQuiz(quizData?.quiz_id)" [disabled]="isStarting">
          <ng-container *ngIf="!isStarting; else loadingStart">
            <span>Start Quiz</span>
            <i class="bi bi-play-fill"></i>
          </ng-container>
          <ng-template #loadingStart>
            <span class="spinner-border spinner-border-sm"></span>
            <span>Initializing...</span>
          </ng-template>
        </button>
      </div>
    </div>
  </ng-template>
</div>